// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aaD-","left":"styles_left__h8F9k"};